/**
 * This component was updated to use the NavLink component from react-router as instructed in the Catalyst documentation:
 * https://catalyst.tailwindui.com/docs#client-side-router-integration
 */
import * as Headless from '@headlessui/react'
import React, { forwardRef } from 'react'
import { NavLink } from 'react-router'

export const Link = forwardRef(function Link(
  props: React.ComponentPropsWithoutRef<typeof NavLink>,
  ref: React.ForwardedRef<HTMLAnchorElement>,
) {
  return (
    <Headless.DataInteractive>
      <NavLink
        {...props}
        ref={ref}
      />
    </Headless.DataInteractive>
  )
})
